import React from 'react';
import {Card, CardContent, Typography, Divider, Box} from "@mui/material";
import './serviceData.css';
import { baseUrl } from '../../../../../../../../../../../../../network/constants/constants';

const ServiceDataCard = ({detailService}) => {
  const { service, price_chart, features } = detailService;

  function convertToAMPM(time) {
    let [hours, minutes] = time.split(':');
    hours = parseInt(hours, 10);
    minutes = parseInt(minutes, 10);
    
    const newFormat = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; 
    minutes = minutes < 10 ? "0" + minutes : minutes;

    return `${hours}:${minutes} ${newFormat}`;
}

console.log(features);

  return (
    <>
      <h2 className="service-heading">{service?.service}</h2>
    <Card sx={{ minWidth: 275 }}>
    <CardContent>
      <Typography variant="h6" sx={{ textAlign: "start", mb: 1.5 }}>
        Features and Service Descriptions
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <div className="key-value">
        <div className="key">Service Name :</div>
        <div className="value">{service?.service}</div>
      </div>
      <div className="key-value">
        <div className="key">Category :</div>
        <div className="value">{service?.category_name}</div>
      </div>

      <div className="key-value">
        <div className="key">Features :</div>
        <div className="value">
        <ul>
            {features?.map((feature, index) => (
              <li
               key={index}
               style={{ display: "flex", alignItems: "center" }}>
                <Box
               sx={{
                width: 16,
                height: 16,
                borderRadius: "50%",
                backgroundColor: feature.color,
                marginRight: 1,
              }}
                />
                {feature.feature_name}
              </li>
           ))} 
          </ul>
        </div>
      </div>

      <div className="key-value">
        <div className="key">Service Description :</div>
        <div className="value">{service?.description}</div>
      </div>

      <Typography variant="h6" sx={{ textAlign: "start", mb: 2, mt: 2 }}>
        Price and Details
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <div className="key-value">
        <div className="key">Price :</div>
        <div className="value">{price_chart?.price_chart}</div>
      </div>
      <div className="key-value">
        <div className="key">Price Heading :</div>
        <div className="value">{price_chart?.text}</div>
      </div>
      <div className="key-value">
        <div className="key">Price Description :</div>
        <div className="value">{price_chart?.details}</div>
      </div>

      <div className="key-value">
        <div className="key">Starting Time :</div>
        <div className="value">
            {service?.open_time}
            </div>
      </div>

      <div className="key-value">
        <div className="key">Ending Time :</div>
        <div className="value">
            {service?.close_time}
            </div>
      </div>
      <div className="key-value">
        <div className="key">Terms and condition :</div>
        <div className="value">{service?.terms_and_condition}</div>
      </div>
      <Typography variant="h6" sx={{ textAlign: "start", mb: 2, mt: 2 }}>
        Service Thumb
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <div className="service-thumbnail">
        {service?.thumb && (
          <img
            src={`${baseUrl}${service?.thumb}`}
            alt={`${service?.service} Thumbnail`}
            style={{
              width: "250px",
              height: "auto",
              borderRadius: "8px", 
              marginBottom: "16px", 
            }}
          />
        )}
      </div>
    </CardContent>
  </Card>
  </>
  )
}

export default ServiceDataCard